import { ExtendedLineItem } from 'shared/types/cart/LineItem';

const configLineItemExtractor = (item: ExtendedLineItem) => {
  if (!item?.config) return '';
  const valueArr = Object.entries(item.config)
    .map(([key, val]) => {
      if (val === 'false' || !val) return '';
      // If value is a boolean, we take its key as the value in a human-readable format: "Wirebrush": true -> "Wirebrush"
      if (val === 'true') return key.charAt(0).toUpperCase() + key.slice(1);

      // If value is a color, we take the value and extract the color name. "color": "Standard Black:#000000" -> "Standard (Black)"
      if (key === 'color' && (val as string).includes(':')) {
        const colorName = (val as string).split(':')[0];
        return colorName;
      }
      return val;
    })
    .filter((val) => val !== '')
    .join(', ');
  return valueArr;
};

export default configLineItemExtractor;
